import React from "react";
import {
  Card,
  CardHeader
} from "material-ui/Card";

import { Editor } from "react-draft-wysiwyg";
import {
  EditorState,
  ContentState,
  convertToRaw
} from "draft-js";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import {injectIntl} from "react-intl";

const toEditorState = html => {
  if (html === "" || !html) {
    const contentState = ContentState.createFromText("");
    return EditorState.createWithContent(contentState);
  } else {
    var blocksFromHTML;
    var contentBlocks;
    blocksFromHTML = htmlToDraft(html);
    contentBlocks = blocksFromHTML.contentBlocks;
    const contentState = ContentState.createFromBlockArray(contentBlocks);
    return EditorState.createWithContent(contentState);
  }
};

const toHtml = editorState => {
  return draftToHtml(convertToRaw(editorState.getCurrentContent()));
};

let toolbarConfig = {
  image: false
};

let editorStyle = {
  height: 250,
  padding: '0 20px'
};

let toolbarStyle = {
  width: "100%",
  padding: "10px 0",
  border: "none",
  borderBottom: "1px solid #efefef",
  display: 'none'
};

class QuestionNoteInlineEditor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      noteState: toEditorState(
        this.props.defaultValue || this.props.question.notesPrompt || ""
      )
    };
  }

  // componentWillReceiveProps(nextProps) {
  //   const nextDefaultValue =
  //     nextProps.defaultValue || nextProps.question.notesPrompt || "";
  //   const oldDefaultValue =
  //     this.props.defaultValue || this.props.question.notesPrompt || "";
  //   if (nextDefaultValue != oldDefaultValue || nextProps.question.id != this.props.question.id) {
  //     this.setState({
  //       noteState: toEditorState(nextDefaultValue)
  //     });
  //   }
  // }

  render() {
    let { open } = this.props;
    const intl = this.props.intl;

    return (
      <Card style={{
        width: '90%',
        margin: '10px auto',
        display: open ? 'block' : 'none',
        backgroundColor: '#fffaf2',
        border: '1px solid #c7c1b5'
      }}>
        <CardHeader title={intl.formatMessage({ id:"general.notes", defaultMessage:"Notes" })} />
        <Editor
          toolbar={toolbarConfig}
          toolbarHidden={true}
          editorStyle={editorStyle}
          toolbarStyle={toolbarStyle}
          editorState={this.state.noteState}
          onEditorStateChange={this.handleEditorStateChange}
        />
      </Card>
    );
  }

  getValue = () => {
    var note = toHtml(this.state.noteState);
    if (note === "<p></p>" || note === "<p></p>\n") {
      note = "";
    }
    return note;
  }

  handleSave = () => {
    var note = toHtml(this.state.noteState);
    if (note === "<p></p>" || note === "<p></p>\n") {
      note = "";
    }
    if (this.props.onSave) {
      this.props.onSave(note);
    }
    this.props.onRequestClose();
  };

  handleCancelClick = () => {
    this.props.onRequestClose();
  };

  handleEditorStateChange = v => {
    this.setState({ noteState: v });
    setTimeout(() => {
      if (this.props.onChange) {
        this.props.onChange(this.getValue());
      }
    }, 10);
  };
}

export default injectIntl(QuestionNoteInlineEditor);
